<template>
  <div class>
    <div class="row p-3">
      <div class="col-lg-12">
        <h3 class="p-3 pl-4">MUDAR STATUS DO PROCESSO SELETIVO.</h3>
        <hr />
      </div>
    </div>

    <div class="row p-3">
      <div class="col-lg-6 col-xs-12">
        <div v-for="(apply, index) in currentApplies" :key="apply.id">
          <div class="candidate_list">
            <div class="row p-3">
              <div class="col-lg-2 col-xs-12">
                <img
                  :src="apply.image || '/images/avatar.png'"
                  class="avatar_thumb"
                />
              </div>
              <div class="col-lg-10 col-xs-12">
                <div @click="deleteCandidate(index)" class="close-alt">
                  <font-awesome-icon
                    :icon="['fas', 'trash-alt']"
                  ></font-awesome-icon>
                </div>
                <span class="f25">
                  <b>{{ apply.name.split(" ")[0] }}</b>
                </span>
                <br />
                <a class="f12" :href="`mailto:${apply.email}`">{{
                  apply.email
                }}</a>
              </div>
            </div>
          </div>
          <hr />
        </div>
      </div>
      <div 
        class="col-lg-6 col-xs-12"
        style="display: flex; flex-wrap: wrap;"
      >
        <div
          class="shadow_bar select_process"
          v-for="process in selective_processes"
          :key="process.id"
          :class="`process${process.status}`"
        >
          <label class="pointer">
            <input
              style
              type="radio"
              v-model="select_process_id"
              name="status"
              :value="process.id"
            />
            {{ process.name }}
          </label>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-6 p-0 m-0 center">
        <button
          @click="changeStatus"
          type="button"
          class="btn radius-0 full btn btn-info"
        >
          ALTERAR STATUS
        </button>
      </div>
      <div class="col-lg-6 p-0 m-0 center">
        <button
          @click="$emit('close')"
          type="button"
          class="radius-0 full btn btn-primary"
        >
          FECHAR
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import ComfirmFeedback from "@/Recruiters/Feedback/Confirm.vue";
import ConfirmQuestions from "@/Recruiters/SelectedQuestions/Confirm.vue";
export default {
  props: ["applies", "selected", "selective_processes"],
  data: () => ({
    select_process_id: 0,
    currentApplies: [],
  }),
  mounted() {
    this.currentApplies = this.selected;
  },
  methods: {
    confirmFeedback(feedback, select_process_id, questions = false, bigfive) {
      this.$modal.show(
        ComfirmFeedback,
        {
          status: true,
          candidates: this.currentApplies,
          feedback: feedback,
          feedback_selective_process: {
            selective_process_id: select_process_id,
          },
        },
        {
          width: "55%",
          height: "auto",
          scrollable: true,
          // dynamicDefaults: {
          clickToClose: false,
          // }
        },
        {
          closed: (event) => {
            if (questions || bigfive)
              this.openConfirmQuestions(select_process_id, bigfive);
          },
        }
      );
    },
    openConfirmQuestions(selective_process_id, bigfive) {
      let selective_process = {};
      for (let process of this.selective_processes) {
        if (selective_process_id === process.id) selective_process = process;
      }

      if (selective_process.status === 1) return;
      this.$modal.show(
        ConfirmQuestions,
        {
          selective_process_uid: selective_process.uid,
          applies: this.currentApplies,
          bigfive,
        },
        {
          width: "55%",
          height: "auto",
          scrollable: true,
          clickToClose: false,
        }
      );
    },
    changeStatus() {
      let apply_ids_current = [];
      for (let apply of this.currentApplies) {
        apply_ids_current.push(apply.id);
      }

      axios
        .put("/recruiters/applies/update_status", {
          candidates: {
            applies_ids: apply_ids_current,
            selective_process_id: this.select_process_id,
          },
        })
        .then((response) => {
          this.$emit("close");
          eventBus.$emit("resetSelected");
          if (response.data.feedback) {
            this.confirmFeedback(
              response.data.feedback,
              this.select_process_id,
              response.data.questions,
              response.data.bigfive
            );
            return;
          }
          if (response.data.questions || response.data.bigfive) {
            this.openConfirmQuestions(
              this.select_process_id,
              response.data.bigfive
            );
          }
          this.$toast.success("Aplicações atualizadas com sucesso");
        });
      return true;
    },
    deleteCandidate(index) {
      let conf = confirm(
        "Tem certeza que deseja tirar esse candidato da lista de mudança de status?"
      );
      if (!conf) return;
      this.currentApplies.splice(index, 1);
    },
  },
};
</script>
